import { DeliveryProgressContainer, DeliveryProgressLine } from './styles';
import { DeliveryProgressType, getIcon } from '../helpers';

interface Props {
  type: DeliveryProgressType;
}

const DeliveryProgress = ({ type }: Props) => {
  const progressIcon = getIcon(type);

  return (
    <DeliveryProgressContainer>
      {progressIcon}
      {type === 'departure' && <DeliveryProgressLine />}
    </DeliveryProgressContainer>
  );
};

export default DeliveryProgress;
